import React, { useMemo } from 'react';
import DefaultReactTable from '../../utils/react-table';

// This is a simple bridge between Rails and a React table.
// See SupportSlaReportController for example usage
const RailsReactTable = ({ data, columns }) => {
  const reactTableColumns = useMemo(
    () =>
      Object.entries(columns).map(([id, metadata]) => ({
        Header: metadata.header,
        id,
        accessor: d => {
          // a row can either be specified as plain value, or as an object
          // with value and display
          const columnData = d[id];
          return columnData && typeof columnData === 'object' ? columnData.value : columnData;
        },
        className: metadata.type === 'number' ? 'text-end' : null,
        Cell: row => {
          const columnData = row.original[id];
          return columnData && typeof columnData === 'object' ? (
            <span dangerouslySetInnerHTML={{ __html: columnData.display }} />
          ) : (
            columnData
          );
        },
        filterable: metadata.filterable === false ? false : true,
        sortable: metadata.sortable === false ? false : true
      })),
    []
  );

  return <DefaultReactTable columns={reactTableColumns} data={data} />;
};

export default RailsReactTable;
